module.exports = __webpack_public_path__ + "static/media/bff1.5b5e722d.png";